import garageLocator from '../quote-tool/modules/garageLocator';
import {replacementModule} from '../quote-tool/modules/replacements';
import {apVehicleSelectorModule} from './modules/vehicleSelector';
import {serviceSelectorModule} from './modules/serviceSelector';
import {apReturnBtn} from './components/apSwitchStep';
import {userInfo} from '../quote-tool/modules/userInfo';
import {summaryModule} from './modules/summary';
import {confirmModule} from '../quote-tool/modules/confirmation';
import {dateSelector} from '../quote-tool/modules/dateSelector';
import {analytics} from '../quote-tool/globals/config';
import apAnalytics from './components/apAnalytics';


export default function () {
    apReturnBtn();
    garageLocator();
    dateSelector();
    replacementModule();
    apVehicleSelectorModule();
    serviceSelectorModule();
    userInfo();
    summaryModule();
    confirmModule();


    apAnalytics('choose-dealer--start');

    jQuery('.js-qt-return-to-homepage').on('click', function () {
        const eventData = {
            event: 'button-click',
            info: {
                buttonType: 'link',
                buttonCategory: 'inbound-link',
                buttonName: 'to-homepage',
                buttonText: $(this).text(),
                buttonTarget: window.location.origin,
                buttonPosition: 'quote-tool',
            },
        };

        analytics.trackEvent(eventData);
        window.location.href = window.location.origin;
    });
}
